import Component from '@glimmer/component';
import {
  PrismButton,
  PrismIllustration,
  PrismModal,
} from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import GeneralNavigationIntercomHelpLink from 'lumen/components/general/navigation/intercom-help-link';
import { CENTRAL_MAPPING_HELP_CENTER_LINKS } from 'lumen/utils/central-mapping-constants';

import styles from './onboarding.module.css';

interface SettingsCurrencyConversionModalsOnboardingSignature {
  Args: {
    onClose: () => void;
  };
}
export default class SettingsCurrencyConversionModalsOnboarding extends Component<SettingsCurrencyConversionModalsOnboardingSignature> {
  hierarchHelpCenterLink = CENTRAL_MAPPING_HELP_CENTER_LINKS.HIERARCHY_PAGE;

  <template>
    <PrismModal @onClose={{@onClose}} class={{styles.onboarding-modal}}>
      <:headerContent>
        <h3 class="flex w-full items-center justify-center pl-1000">
          {{t "settings.currency_conversion.onboarding.header"}}
        </h3>
      </:headerContent>

      <:default>
        <section>
          <PrismIllustration
            @name="200x200_currencies"
            @size="unsafe_unconstrained"
          />

          <div
            class="paragraph-300--regular flex flex-col items-center gap-400 px-500 pb-500 text-center"
          >
            <p>{{t "settings.currency_conversion.onboarding.description1"}}
            </p>

            <p>{{t "settings.currency_conversion.onboarding.description2"}}</p>
            <GeneralNavigationIntercomHelpLink
              @articleLink="en/articles/13689943-currency-in-lighthouse"
              @iconName="book"
              @iconPlacement="before"
              @isStandaloneLink={{true}}
              @linkText={{t
                "settings.currency_conversion.onboarding.link_text"
              }}
              @textSize="small"
              @type="text-and-icon"
              data-test-id="help-center-button"
            />
          </div>

        </section>
      </:default>

      <:footer>
        <div class="flex h-full items-center justify-end px-500">
          <PrismButton
            @buttonType="primary"
            @label={{t "general.got_it"}}
            @onClick={{@onClose}}
          />
        </div>
      </:footer>
    </PrismModal>
  </template>
}
